export default "data:image/webp;base64,UklGRj4AAABXRUJQVlA4IDIAAADwAQCdASoFAAYAAgA0JQBOjXAAWZ6lR4AA/tXGlhiUBlz8kHwmZlqpMa3iGCWOApmQAA=="